import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  considering: number,
 *  planning: number,
 *  onHold: number,
 *  ready: number }} projectStatus
 */

const api = new Api("api/communications");

/**
 * @returns {Promise<AxiosResponse<projectStatus>>}
 */
export const getProjectStatus = () => api.get("projects/status-graph");
